import {FlexGap, StackHorizontal} from "@twigsby/frontend-framework";
import React from "react";
import FilterItem from "../FilterItem";
import {ActiveFilterEntriesType} from "./FilterTypes";

const ActiveFilterEntries = (props: ActiveFilterEntriesType) => {
    const filterEntries =[];

    if(props.activeFilters) {
        for (const [key, value] of Object.entries(props.activeFilters)) {
            filterEntries.push(
                <FilterItem content={value.friendlyValue || value.value} key={`activeFilterEntry${key}`} callback={() => props.removeFilterCallback(key)} />
            );
        }
    }

    return (
        <StackHorizontal gap={FlexGap.ExtraSmall} wrap={true}>
            {filterEntries}
        </StackHorizontal>
    )
}

export { ActiveFilterEntries }
